import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 20px;
`

export const Content = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08);
  padding: 32px;
  width: 100%;
  max-width: 600px;
`

export const Header = styled.div`
  text-align: center;
  margin-bottom: 25px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 18px;

  h2 {
    color: #0f172a;
    font-weight: 700;
    margin: 0 0 8px 0;
  }
  
  p {
    color: #475569;
    margin: 0;
    font-size: 14px;
  }
`

export const InfoSection = styled.div`
  margin-bottom: 20px;

  h3 {
    color: #0f172a;
    margin: 0 0 10px 0;
    font-size: 16px;
    font-weight: 700;
  }
`

export const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;

  strong {
    font-size: 11px;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 700;
    margin-bottom: 4px;
  }

  span {
    font-size: 15px;
    color: ${({ theme }) => theme.colors.text};
    font-weight: 500;
  }
`

export const ActionButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: bold;
  margin-top: 30px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`
